import "jquery-validation"
import "../validator-rules";
import "select2";
import Pikaday from "pikaday"
import moment from "moment";
import ssoAjax from "../tools/sso.ajax";
import ssoAlert from "../tools/sso.alert";
import ssoTool from "../tools/sso.tool";

export function init() {
    if (window.socialBindStatus === 'success') {
        ssoAlert.success(language.profile.bind_success);
    } else if (window.socialBindStatus === 'failed') {
        const reason = window.socialBindError;
        ssoAlert.error(language.profile.bind_error[reason] || language.profile.bind_failed);
    }

    const profileForm = $('#profile_form');
    const btnEdit = $('#btn_edit');
    const btnCancel = $('#btn_cancel');
    const btnSubmit = $('#btn_submit');
    const cardFooter = $('#profile_card_footer');
    const thisYear = parseInt(moment().format('YYYY'));
    const startYear = thisYear - 100;
    const formTitle = $('#form_title');
    const datePicker = new Pikaday({
        field: document.getElementById('birthday'),
        format: 'YYYY-MM-DD',
        yearRange: [startYear, thisYear]
    });

    ssoTool.setInputClearSwitch(['#last_name', '#first_name', '#email', '#phone', '#birthday']);
    $('#birthday').next('i[name="clear"]').on('mousedown', function(e) {
        e.preventDefault();
        datePicker.setDate(null);
    });

    ssoAjax
        .checkToken()
        .authSubmit(coreProfileUrl, function(response) {
            let user = response.data.user;

            $('[name="last_name"]').val(user.last_name);
            $('[name="first_name"]').val(user.first_name);
            $('[name="account"]').val(user.account);
            $('[name="email"]').val(user.email);
            $('[name="phone"]').val(user.phone);
            $('[name="gender"]').val(user.gender);
            $('[name="birthday"]').val(user.birthday);
            $('[name="timezone"]').val(user.timezone).trigger('change');

            if (moment(user.birthday, 'YYYY-MM-DD', true).isValid()) {
                datePicker.setDate(moment(user.birthday).toDate());
            }

            if (user.birthday === '') {
                datePicker.setDate(moment().subtract(30, 'years').toDate());
            }
        }, function() {
            ssoAjax.redirectToLogin();
        });

    const enterViewMode = function() {
        profileForm.find('input:text, select').not('[name="account"]').prop('disabled', true);
        ssoTool.hideClearIcons(profileForm);
        cardFooter.addClass('d-none');
        btnEdit.removeClass('d-none');
        formTitle.text(language.form_title.origin);
    };

    btnEdit.on('click', function() {
        profileForm.find('input:text, select').not('[name="account"]').prop('disabled', false);
        btnEdit.addClass('d-none');
        cardFooter.removeClass('d-none');
        formTitle.text(language.form_title.edit_mode);
        return false;
    });

    btnCancel.on('click', function() {
        ssoAlert.confirm(
            language.edit_profile.cancel_confirm.title,
            language.edit_profile.cancel_confirm.html,
            function() {
                enterViewMode();
            }
        );
    });

    profileForm.validate({
        showErrors: function() {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            ssoAjax
                .withAuth()
                .setOptions({
                    method: 'put',
                    url: coreProfileUrl,
                })
                .submit(form, function(response) {
                    try {
                        if (response.status === true) {
                            ssoAlert.success(language.edit_profile.update_success);
                            enterViewMode();
                        } else {
                            ssoAlert.error(language.edit_profile.update_failed);
                        }
                    } catch (e) {
                        ssoAlert.error(e.message);
                    }

                    ssoAjax.btnSetToSubmit();
                });
        }
    });

    $('[name="timezone"]').select2({
        width: '100%',
    });

    $(document).on('click', '.btn-unbind', function() {
        const btn = $(this);
        const url = btn.data('url');
        const providerName = btn.data('provider-name');
        const confirmHtml = language.profile.unbind_confirm_html.replace(':provider', providerName);

        ssoAlert.confirm(
            language.profile.unbind_confirm_title,
            confirmHtml,
            function() {
                $.ajax({
                    url: url,
                    method: 'DELETE',
                    dataType: 'json',
                    headers: {
                        'Authorization': `Bearer ${ssoAjax.getToken()}`
                    }
                }).done(function(response) {
                    if (response.status === true) {
                        ssoAlert.success(language.profile.unbind_success);
                        setTimeout(function() { location.reload(); }, 1500);
                    } else {
                        ssoAlert.error(language.profile.unbind_failed);
                    }
                }).fail(function() {
                    ssoAlert.error(language.profile.unbind_failed);
                });
            }
        );
    });
}
